import $ from 'jquery';

$(async function () {
  if ($('#single-event-map').length) {
    // Create the script tag, set the appropriate attributes
    var script = document.createElement('script');
    const googleMapsAPI = 'https://maps.googleapis.com/maps/api/';
    const googleAPIKey = 'AIzaSyDiUg2Y4cK2hvqx2EUf2n8GtKhRsaxa-2s';

    script.src = `${googleMapsAPI}js?key=${googleAPIKey}&callback=initMap`;
    script.async = true;

    let map;
    const address = $('#single-event-map').data('address');

    const { results } = await $.ajax({
      url: `${googleMapsAPI}geocode/json?address=${encodeURIComponent(
        address
      )}&key=${googleAPIKey}`
    });

    const coordinates = results[0].geometry.location;

    // Attach your callback function to the `window` object
    window.initMap = function () {
      // JS API is loaded and available
      map = new google.maps.Map(document.getElementById('single-event-map'), {
        center: coordinates,
        zoom: 13
      });

      new google.maps.Marker({
        position: coordinates,
        map
      });
    };

    // Append the 'script' element to 'head'
    document.head.appendChild(script);
  }
});
